<template>
  <div style="display: grid; grid-template-rows: auto 1fr auto; height: 100vh">
    <navbar></navbar>
    <div style="max-height: 100%; overflow: scroll">
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </div>
    <footerLogo/>
  </div>
</template>
<script>
import navbar from "../navbar/navbar.vue";
import footerLogo from "../footer/footer.vue";
export default {
  components: {footerLogo, navbar },
};
</script>
